import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import { useMultistepForm } from "@/hooks/useMultistepForm";
import Spinner from "@/components/Spinner";
import Form from "./Form";
export default function MultiForm({ allForms, isCheckingOut, onSubmit, children, submitText, }) {
    const { forms, currentStepIndex, form, back, isFirstStep, isLastStep, next } = useMultistepForm(allForms);
    const [formSubmission, setFormSubmission] = useState({
        is_checking_out: isCheckingOut,
        submissions: [],
    });
    const [submitting, setSubmitting] = useState(false);
    if (submitting)
        return _jsx(Spinner, { text: "Submitting..." });
    function updateSubmission(submission) {
        const newSubmission = { ...formSubmission };
        newSubmission.submissions[currentStepIndex] = submission;
        setFormSubmission(newSubmission);
    }
    function formSubmit(submission) {
        const newSubmission = { ...formSubmission };
        newSubmission.submissions[currentStepIndex] = submission;
        setFormSubmission(newSubmission);
        if (!isLastStep) {
            return next();
        }
        setSubmitting(true);
        if (isCheckingOut) {
            if (onSubmit) {
                onSubmit(true, {
                    is_checking_out: isCheckingOut,
                    submissions: newSubmission.submissions,
                });
            }
            return;
        }
        fetch(`/api/forms/submit`, {
            method: "POST",
            body: JSON.stringify(newSubmission),
            headers: {
                "Content-Type": "application/json",
            },
        }).then((resp) => {
            if (resp.ok) {
                setSubmitting(false);
            }
        });
    }
    const formsElement = forms.map((_, index) => {
        return (_jsx(Fragment, { children: index === currentStepIndex ? (_jsx("i", { className: "bi bi-circle-fill text-primary" })) : (_jsx("i", { className: "text-gray-500 bi bi-circle" })) }, index));
    });
    return (_jsxs("article", { className: "flex flex-col gap-2 w-full", children: [_jsx("section", { role: "progressbar", className: "flex flex-row flex-wrap gap-4 justify-center list-none", children: formsElement }), _jsx(Form, { updateSubmission: updateSubmission, submit: formSubmit, activeForm: form, children: children, isFirstStep: isFirstStep, isLastStep: isLastStep, index: currentStepIndex, isCheckingOut: isCheckingOut, back: back, submitText: submitText, submissions: formSubmission.submissions }, currentStepIndex)] }));
}
//# sourceMappingURL=MultiForm.js.map